import React from 'react';
import { wpToCF } from '../../utils/data/cdn';
import styles from './styles.module.css';

interface Props {
  title: string;
  image?: string;
}

const SubpageHero = ({ title, image }: Props) => {
  return (
    <div className={`flex ${styles.hero}`}>
      <div className='hidden sm:block flex-grow flex-shrink-0 relative'>
        <img
          className={`absolute ${styles.image}`}
          src={wpToCF(image)}
          alt={title}
        />
      </div>
      <div
        className={`w-full sm:w-auto flex items-center justify-center sm:block flex-grow flex-shrink-0 relative p-4`}
      >
        <h1
          className={`font-bold relative sm:absolute block text-abn-brown leading-none text-3xl sm:text-4xl md:text-5xl w-full font-sans ${styles.header}`}
        >
          {title}
        </h1>
      </div>
    </div>
  );
};

export default SubpageHero;
